<mc-scope>
    <mc-auth id="mc-auth" #auth [attr.auth-url]="pdauthURL" show-user="false" app-name="TIRE" prefix="Logged in as ">
    </mc-auth>
    <app-header id="header" #header></app-header>
    <app-score-panel></app-score-panel>
    <div class="main-area">
        <div class="legend-area" [ngClass]="{'closed': legendClosed }">
            <div class="loader is-active padding-leader-3 padding-trailer-3">
                <div class="loader-bars"></div>
            </div>
            <mc-legend id="mc-legend" class="legend block-display" #legend slot="legend" show-layer-detail="false"
                [ngClass]="{'show': !loadingArea }" (optionSelectedEvent)="onOptionSelect($event)"
                (attached)="optionsAttached($event)" (onsymbolchange)="onSymbolEditorClick($event)" readonly="true">
                <div slot="legend-layer-options" class="legend-layer-options dropdown js-dropdown">
                    <button class="btn btn-transparent dropdown-btn icon-ui-settings layer-options-button" tabindex="0"
                        aria-haspopup="true" aria-expanded="false"></button>
                    <nav class="legend dropdown-menu dropdown-right" role="menu">
                        <button class="dropdown-link details-option" role="menuitem">
                            <span class="esri-icon-documentation"></span>
                            Details
                        </button>
                        <button class="dropdown-link filter-option" role="menuitem">
                            <span class="esri-icon-filter"></span>
                            Filter
                        </button>
                        <button class="dropdown-link delete-option" role="menuitem">
                            <span class="esri-icon-close"></span>
                            Delete
                        </button>
                        <button class="dropdown-link export-shapefile-option" role="menuitem">
                            <span class="esri-icon-download"></span>
                            Export Shapefile
                        </button>
                        <button class="dropdown-link copy-option" role="menuitem">
                            <span class="esri-icon-minimize"></span>
                            Copy
                        </button>
                    </nav>
                </div>
            </mc-legend>
        </div>
        <button class="legend-expander icon-ui-up-down-arrows btn btn-white" [ngClass]="{'closed': legendClosed }"
            (click)="toggleLegend()">
        </button>

        <div class="map-container" [ngClass]="{'full': legendClosed }">
            <mc-map id="mc-map" #map center="[-77.6362661695295, 40.92039887644528]" zoom="8"
                (largerImageRequest)="largerImageRequest($event)">
                <div slot="top-left">
                    <mc-extent #extent></mc-extent>
                </div>
                <mc-expander slot="top-left" expand-icon-class="esri-icon-basemap" auto-collapse="true"
                    expand-tooltip="Basemap">
                    <mc-basemap-switcher #basemapSwitcher></mc-basemap-switcher>
                </mc-expander>
                <mc-identify #identify slot="top-right" (featureUpdated)="featureUpdated($event)"
                    (docSourcesUpdated)="docSourcesUpdated($event)">
                    <app-identify-buttons slot="report-links"></app-identify-buttons>
                </mc-identify>
                <mc-import-shapefile #importShapefile id="importShapefile" (onfiledrop)="onImportShapefileDrop($event)" (onfiledone)="onImportShapefileDone($event)"></mc-import-shapefile>
                <mc-layer-tooltip id="tooltip" #tooltip slot="content" tooltip-enabled="false"></mc-layer-tooltip>
            </mc-map>

            <div (click)="dismissMapLoader()" class="map loader is-active padding-leader-3 padding-trailer-3"
                [ngClass]="{'show': showMapLoader }" [title]="mapLoaderTitle">
                <div class="loader-bars"></div>
            </div>

        </div>
    </div>

    <mc-export-layer id="exportLayer" #exportLayer style="display:none"></mc-export-layer>

    <mc-window #disclaimerWindow id="disclaimerWindow" title="Disclaimer" width="875" modal="true">
        <div slot="content">
            <div class="disclaimer">
                <p class="welcome">
                    Welcome to TIRe (Traffic Information Repository), a web application for providing traffic count data
                    to various agencies and to the public. TIRe is designed to enable Internet users to view interactive
                    maps of traffic counter site locations and traffic count information for roadways throughout the
                    Commonwealth of Pennsylvania.
                </p>
                <p class="text">
                    The Commonwealth of Pennsylvania, acting through the Pennsylvania Department of Transportation
                    (PennDOT), provides the information and data contained on this website in good faith. PennDOT makes
                    no claims, promises, or guarantees about the accuracy, completeness, or adequacy of the Data.
                    PennDOT shall have no liability for the Data which is provided “as is” and without any warranty
                    whatsoever, express or implied. The Data is and shall remain the property of PennDOT and shall be
                    clearly identified and marked as such by the user in all media. PennDOT assumes no liability for any
                    virus or other damage to any computer that occurs as the result of accessing the Data. PennDOT
                    reserves the right to make improvements and/or changes to the products or programs within this
                    application at any time, with or without notice.
                </p>
                <div class="buttons">
                    <button class="btn accept" (click)="acceptDisclaimer()">Accept</button>
                    <button class="btn btn-clear cancel" (click)="doNotAcceptDisclaimer()">I Do Not Accept</button>
                </div>

            </div>
        </div>
    </mc-window>

    <mc-window #filterLayerOptionsWindow id="filterLayerOptions" title="Filter Layer Options" modal="true" width="600">
        <div slot="content">
            <h4>Select a filter option for each layer.</h4>
            <div *ngFor="let layer of selectedLayers" class="selected-layer">
                <span>{{layer.name}}</span>
                <div class="fieldset-radio filter-type-picker">
                    <label>
                        <input type="radio" [name]="layer" value="showAll" [(ngModel)]="layer.filterType">Show
                        All
                    </label>
                    <label><input type="radio" [name]="layer" value="filter" [(ngModel)]="layer.filterType">Filter</label>
                    <label *ngIf="layer.aoiQuery?.field || layer.aoiQuery?.subqueries"><input type="radio" [name]="layer" value="aoi" [(ngModel)]="layer.filterType">AOI</label>
                </div>
            </div>
            <button class="btn btn-small btn-red" style="float:right;"
                    (click)="closeFilterLayerOptionsWindow()">
                Cancel
            </button>
            <button class="btn btn-small" style="float:right; margin-right: 10px;" (click)="setFilters()">Next</button>
        </div>
    </mc-window>

    <mc-window #layerFilterContainerWindow id="layerFilterContainerWindow" title="Layer Filter" is-resizable="true" is-draggable="true"
            top="100" height="700" width="960">
        <div slot="content">
            <mc-layer-filter-container #layerFilterContainer id="layerFilter" enable-geographic-filter="false" enable-join-filter="false" enable-child-record-filter="false"></mc-layer-filter-container>
        </div>
    </mc-window>

    <mc-window #spatialQueryWindow id="spatialQueryWindow" title="Spatial Query" is-draggable="true" is-resizable="true"
        top="100" width="960">
        <mc-layer-spatial-query #spatialQuery id="spatialQuery" slot="content"></mc-layer-spatial-query>
    </mc-window>

    <mc-window #symbolEditorWindow id="symbolEditorWindow" title="Symbol Editor" is-draggable="true" is-resizable="true"
        width="530" top="75" left="300">
        <mc-symbol-editor-container #symbolEditor id="symbolEditor" slot="content">
            <mc-point-symbol-editor slot="point-symbol-editor"></mc-point-symbol-editor>
            <mc-line-symbol-editor slot="line-symbol-editor"></mc-line-symbol-editor>
            <mc-polygon-symbol-editor slot="polygon-symbol-editor"></mc-polygon-symbol-editor>
            <mc-text-symbol-editor slot="text-symbol-editor"></mc-text-symbol-editor>
            <mc-layer-opacity-editor slot="layer-opacity-editor"></mc-layer-opacity-editor>
        </mc-symbol-editor-container>
    </mc-window>

    <mc-application-messages #applicatoinMessages class="application-messages" duration-in-ms="50000000"
        notification-levels="[0,1,2,3]">
    </mc-application-messages>

    <div class="data-table-container" [ngClass]="{ 'closed': dataTableMinimized, 'hidden': !dataTable.opened }">
        <mc-data-table id="dataTable" #dataTable slot="bottom-left" autogenerate-column-settings="true"
            max-default-columns="8" mc-data-table="">
        </mc-data-table>
        <button class="data-expander icon-ui-up-down-arrows btn btn-white" *ngIf="dataTableOpened"
            (click)="dataTableMinimized = !dataTableMinimized;"></button>
    </div>

</mc-scope>